<template>
    <div class="apprentice-simple-card">
        <div
            class="rubric-main-settings"
            v-if="rubric">
            <div class="component-title rubric-title">
                <h2>
                    {{
                        rubric.title === '' || rubric.title === null
                            ? $t('rubrics.give_this_rubric_a_title')
                            : rubric.title
                    }}
                </h2>
                <i
                    class="fas fa-pencil btn-edit-title"
                    @click="show"></i>
            </div>

            <div class="rubric-description-settings">
                <div class="rubric-description">

                    <design-2021-apprentice-display-html-component
                        :html-content="rubricDescription"></design-2021-apprentice-display-html-component>

                    <i class="fas fa-pencil btn-edit-description" @click="show"></i>
                </div>

                <div class="rubric-advanced-options-toggle">
                    <b-form-checkbox
                        v-model="rubric.show_values"
                        :name="$t('rubrics.display_value_and_weight')"
                        switch
                        :unchecked-value="0"
                        :value="1"
                        @change="updateRubric">
                        {{ $t('rubrics.display_value_and_weight') }}
                    </b-form-checkbox>
                </div>

                <design-2021-rubric-edit-title-and-description-modal-component :rubric-in="rubric">
                </design-2021-rubric-edit-title-and-description-modal-component>
            </div>
        </div>

        <div
            class="rubric"
            v-if="rubric">
            <design-2021-rubric-edit-grid-component
                v-for="section in rubric.rubric_sections"
                :key="section.id"
                :section-in="section"
                :rubric-show-advanced-options="!!rubric.show_values"
                :rubric-sections-in="rubric.rubric_sections">
            </design-2021-rubric-edit-grid-component>

            <div class="row">
                <div class="col-12">
                    <div class="add-sub-rubric">
                        <b-button
                            class="btn-add-circle btn-add-sub-rubric"
                            v-b-modal="'add-rubric-section'"
                            variant="outline-primary">
                            <div class="text">
                                {{
                                    rubric.rubric_sections && rubric.rubric_sections.length === 0
                                        ? $t('rubrics.add_rubric')
                                        : this.$t('rubrics.add_share_rubric')
                                }}
                            </div>
                        </b-button>
                    </div>
                </div>

                <design-2021-rubric-add-section-modal-component :rubric-in="rubric">
                </design-2021-rubric-add-section-modal-component>
            </div>
        </div>
    </div>
</template>

<script>
import { ords } from '../../app';

const rubricOrds = ords.use('rubric');

export default {
    name: 'design-2021-rubric-edit-component',
    props: {
        rubricIn: Object
    },
    data() {
        return {
            rubric: null,
            items: [
                { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
                { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
                { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
                { age: 38, first_name: 'Jami', last_name: 'Carney' }
            ]
        };
    },
    methods: {
        deleteSection: function(section) {
            this.alert
                .confirm(this.$t('rubrics.delete_section'), this.$t('rubrics.delete_section_confirmation_body'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();

                    this.axios.delete(this.routes.deleteRubricSection(section.id)).then(
                        (response) => {
                            section.remove();

                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        }
                    );
                });
        },

        show() {
            this.$bvModal.show('rubric-edit-main-settings-modal');
        },

        showAddRowModal(section) {
            if (section.rubric_rows.length) {
                const lastIndex = section.rubric_rows.length - 1;
                const row = section.rubric_rows[lastIndex];
                this.$refs['rubric-edit-add-row'].show(row, false, this.rubric.show_values, section.rubric_rows);
            } else {
                const row = {
                    section_id: section.id,
                    order: 0
                };
                this.$refs['rubric-edit-add-row'].show(row, false, this.rubric.show_values, section.rubric_rows);
            }
        },

        updateRubric(checked) {
            const data = {
                title: this.rubric.title,
                description: this.rubric.description,
                show_values: checked
            };

            this.alert.saving();
            this.axios.post(this.routes.updateRubric(this.rubric.id), data).then(
                (response) => {
                    this.rubric.update(data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                }
            );
        },

        showAddColumnModal(section) {
            const column = {
                section_id: section.id
            };
            this.$refs['rubric-edit-column-update'].show(
                column,
                false,
                this.rubric.show_values,
                section.rubric_columns
            );
        }
    },

    computed: {
        rubricSectionData() {
            if (this.rubric && this.rubric.hasSections() && this.rubric.hasRows()) {
                const rows = this.rubric.rubric_sections.map((section) => {
                    for (const row of section.rubric_rows) {
                        let rowHeading = {
                            section_row_heading: row.title,
                            label: row.title,
                            id: row.id,
                            order: row.order,
                            weight: row.weight,
                            section_id: row.section_id
                        };

                        const cells = [];

                        if (this.rubric.hasColumns()) {
                            for (const column of section.rubric_columns) {
                                for (const cell of column.rubric_cells) {
                                    if (cell.row_id === row.id) {
                                        cells.push({
                                            id: cell.id,
                                            column_id: cell.column_id,
                                            row_id: cell.row_id,
                                            value: cell.value
                                        });
                                    }
                                }
                            }
                        }

                        if (cells.length >= 1) {
                            cells.unshift(rowHeading);
                        }

                        return cells;
                    }
                });
            }

            return [];
        },

        rubricSectionFields() {
            if (this.rubric && this.rubric.hasSections() && this.rubric.hasColumns()) {
                const fields = this.rubric.rubric_sections.map((section) => {
                    const heading = {
                        key: 'section_row_heading',
                        label: section.title,
                        id: section.id,
                        order: section.order,
                        weight: section.weight
                    };

                    const columns = section.rubric_columns.map((column) => {
                        return {
                            key: column.title,
                            title: column.title,
                            id: column.id,
                            value: column.value,
                            order: column.order,
                            section_id: column.section_id
                        };
                    });

                    columns.unshift(heading);
                    return columns;
                });
                return fields;
            }

            return [];
        },

        rubricDescription() {
            return this.rubric.description === '' || this.rubric.description === null
                ? this.$t('rubrics.this_rubric_has_no_extra_explanation')
                : this.rubric.description;
        }
    },

    mounted() {
        rubricOrds.add(this.rubricIn);

        rubricOrds
            .with('rubric_sections', (sections) => {
                sections.with('rubric_columns', (columns) => {
                    columns.with('rubric_cells');
                    columns.orderBy('order', 'asc');
                });
                sections.with('rubric_rows', (rows) => {
                    rows.with(['rubric_cells']);
                    rows.orderBy('order', 'asc');
                });
                sections.orderBy('order', 'asc');
            })
            .find(this.rubricIn.id)
            .subscribe((rubric) => {
                this.rubric = rubric;
            });
    },

    watch: {
        rubricIn: {
            handler(value) {
                this.rubric = value;
            },
            deep: true
        }
    }
};
</script>

<style scoped lang="scss">
.rubric-main-settings {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.rubric-title,
.rubric-description {
    display: flex;
    justify-content: flex-start;
    align-content: center;
}

.rubric-title {
    flex: 1 0 100%;
}

.rubric-title h2 {
    margin-bottom: 0;
}

.rubric-title:hover,
.rubric-description:hover {
    cursor: pointer;

    i {
        color: $primary;
        align-self: flex-start;
        font-size: 1.3125rem;
    }
}

.rubric-title .btn-edit-title,
.rubric-description .btn-edit-description {
    opacity: 0;
    color: $text-color;
    align-self: center;
    font-size: $default-font-size;
    margin-left: map-get($grid-gutter-spacing, 'fifteen');
}

.rubric-title .btn-edit-title {
    align-self: center;
}

.rubric-title:hover .btn-edit-title,
.rubric-description:hover .btn-edit-description {
    opacity: 1;
    cursor: pointer;
}

.rubric-main-settings .rubric-description-settings {
    display: flex;
    flex: 1;
    flex-direction: column;
}

.rubric-description {
    margin-right: map-get($grid-gutter-spacing, 'fifteen');
}

.rubric-description p {
    font-size: $default-font-size;
    color: $text-muted-color;
}

.rubric-description p:last-of-type {
    margin-bottom: 0;
}

.rubric-advanced-options-toggle {
    margin-left: auto;
}

.rubric-advanced-options-toggle ::v-deep label {
    font-weight: $font-weight-medium;
}

.rubric-advanced-options-toggle ::v-deep label:before {
    top: 1px;
}

.rubric-advanced-options-toggle ::v-deep label:after {
    top: 3px;
}

.rubric-section {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
}

.rubric-section + .rubric-section {
    margin-top: 60px;
}

.rubric-headings {
    width: 210px;
    border-top: 1px solid $border-color;
    border-left: 1px solid $border-color;
}

.rubric-task {
    display: flex;
    justify-content: space-between;
    height: 75px;
    background-color: $secondary-background-color;
    padding: map-get($grid-gutter-spacing, 'eight');
    border-bottom: 1px solid $border-color;
}

.rubric-task-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: baseline;
    height: 100%;
}

.rubric-task .title {
    font-size: 1rem;
    font-weight: $font-weight-medium;
    margin-bottom: 3px;
}

.rubric-task .weight {
    font-size: 0.75rem;
    font-weight: $font-weight-bold;
    color: $text-color;
}

.rubric-task .label {
    margin-right: 5px;
}

.rubric-navs {
    display: flex;
    flex-direction: column;
    align-self: flex-start;
}

.nav-context ::v-deep {
    margin-top: -3px;

    .btn-remove-rubric .dropdown-item {
        display: flex;
        flex-direction: row;
        align-items: center;

        i {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.nav-context ::v-deep .dropdown-menu .btn-edit-rubric i {
    color: $primary;
}

.nav-context ::v-deep .dropdown-menu .btn-remove-rubric i {
    color: $danger;
}

.rubric-skill {
    display: flex;
    justify-content: space-between;
    padding: map-get($grid-gutter-spacing, 'eight');
    flex-direction: row;
    background-color: $white;
    border-bottom: 1px solid $border-color;
    height: 120px;
}

.rubric-skill > div:first-child {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
}

.rubric-values {
    display: flex;
    overflow-x: auto;
    border-left: 1px solid $border-color;
    //border-right: 1px solid $border-color;
    background-color: rgba($secondary-background-color, 0.25);
    width: calc(100% - 210px);
}

.rubric-column {
    width: 210px;
    border-top: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
    //border-right: 1px solid $border-color;
}

.rubric-action {
    display: flex;
    align-content: center;
    align-self: center;
    align-items: center;
    justify-content: center;
}

.add-sub-rubric,
.add-rubric-row,
.add-rubric-column {
    display: flex;
    justify-content: center;

    .btn {
        flex-direction: column;

        &:before {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            margin-right: 0;
        }
    }
}

.add-rubric-column {
    height: 100%;
    width: 210px;
    max-width: 210px;
    flex: 1 0 210px;
    padding-top: 3px;
    justify-content: center;
    border-right: 1px solid $border-color;
    border-top: 1px solid $border-color;
    border-bottom: 1px solid $border-color;

    .btn {
        align-self: flex-start;

        .text {
            width: max-content;
        }
    }
}

.add-rubric-row {
    height: 120px;
    border-bottom: 1px solid $border-color;
    justify-content: center;

    .btn {
        align-self: center;
    }
}

.add-sub-rubric {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one') * 2;
}

@media (min-width: 1200px) {
    .rubric-main-settings .rubric-description-settings {
        display: flex;
        flex: 1;
        flex-direction: row;
    }

    .rubric-description {
        max-inline-size: 1170px;
        margin-right: 0;
    }
}
</style>
